import { render, staticRenderFns } from "./workDeductionList.vue?vue&type=template&id=48eae72a&scoped=true"
import script from "./workDeductionList.vue?vue&type=script&lang=js"
export * from "./workDeductionList.vue?vue&type=script&lang=js"
import style0 from "./workDeductionList.vue?vue&type=style&index=0&id=48eae72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eae72a",
  null
  
)

export default component.exports